<template>
    <div class="chat">
      <div class="chat-item max-sm:hidden">
        <img class="w-[32px] h-[32px] mr-[5px]  absolute top-0 left-[-40px]" v-if="isUser" src="@/assets/icon_user.png" alt="">
        <img class="w-[32px] h-[32px] mr-[5px]  absolute top-0 left-[-40px]" v-else src="@/assets/icon_robot.png" alt="">
        <div class="w-full rounded-[10px] chat-wrapper" :class="{'text-[#A0A3AE]': isUser }">
          <div class="markdown-body" v-html="content"></div>
        </div>
      </div>
      
      <div class="sm:hidden w-full px-4 ">
        <div class="flex items-end justify-end" v-if="isUser">
          <div class="w-max py-4 pl-3 pr-6 bg-[#4C5BDF] text-white rounded-[10px] rounded-tr-none break-words" v-html="content"></div>
        </div>
        <div v-else class="py-4 pr-3 pl-6 bg-[#fff] text-[#333333] rounded-[10px] rounded-tl-none" v-html="content"></div>
      </div>

      <div class="more_btn flex max-sm:px-4" :class="(isAssistant && !(isFetching && chatItem.isLoading)) ? 'justify-between': ''">
        <div class="stop_btn" @click="$emit('handleClick', 'close')" v-if="isFetching && chatItem.isLoading">
          <button>
            <img class="w-[12px] h-[12px] mr-[5px]" src="@/assets/icon_stop.png" alt="">
            停止生成
          </button>
        </div>
        <div class="ai_answer_tip" v-if="isAssistant && !isFetching">
          以上内容由AI生成，仅供参考
        </div>
        <div v-if="isAssistant && !isFetching" class="copy_btn max-sm:ml-4 "  v-clipboard:copy="tagContent" 
          v-clipboard:success="copySuccess" v-clipboard:error="copyError"
        >复制</div>
      </div>
    </div>
</template>
<script>
import { renderMarkdown, removeHtmlTags } from "@/utils/util";
export default {
    props: ['chatItem', 'isFetching'],
    data() {
        return {}
    },
    computed: {
        isUser() {
            return this.chatItem.role === 'user'
        },
        isAssistant() {
            return this.chatItem.role === 'assistant'
        },
        content() {
            let content =  this.chatItem.content ? this.chatItem.content : '';
            if (content.length <= 0) {
              return '<span class="generating"></span>';
            }
            // if (this.chatItem.isLoading && content.length <= 0) { // 生成中...
            //     return '<span class="generating"></span>';
            // }
            // if (this.chatItem.isLoading) { // loading 加载中
            //     content += '<span class="typing blinker"></span>';
            // }
            return renderMarkdown(content);
        },
        tagContent() {
           let content = this.chatItem.content ? this.chatItem.content : '';
          //  return removeHtmlTags(content);
          return content;
        }
    },
    methods: {
		copySuccess (e) {
			// this.$message.success('复制成功！')
      this.$message({
        message: '复制成功！',
        type: 'success',
        center: true
      });
		},
		// 复制失败
		copyError (e) {
			// this.$message.error('复制失败！')
      this.$message({
        message: '复制失败！',
        type: 'error',
        center: true
      });
		}
    }
}
</script>
<style lang="scss" scoped>
.chat {
  @apply relative;
  word-wrap: break-word;
  &-item {
	@apply mt-[10px] relative;
  }
  &-header {
    @apply flex flex-row justify-between items-center;
    &_title {
      @apply text-[20px] font-bold;
      color: var(--text-primary-color);
    }
    &_time {
      @apply text-[14px] font-normal;
      color: var(--text-gray-color);
    }
  }
  &-wrapper {
    @apply flex flex-col px-[20px] py-[15px] bg-white rounded-[20px] text-base font-normal;
  }
}
:deep(.typing::after) {
  content: '▌';
}
// 光标闪烁动画
:deep(.blinker::after) {
  animation: blinker 1s step-end infinite;
}
@keyframes blinker {
  0% {
    visibility: visible;
  }
  50% {
    visibility: hidden;
  }
  100% {
    visibility: visible;
  }
}

:deep(.generating) {
  font-size: 16px;
  color: var(--text-gray-color);
  &::after {
    content: '生成中';
    animation: generating 3s infinite;
  }
}
@keyframes generating {
  0% {
    content: '生成中';
  }
  25% {
    content: '生成中.';
  }
  50% {
    content: '生成中..';
  }
  75% {
    content: '生成中...';
  }
}
.more_btn {
	@apply flex flex-row items-center my-[8px];
	.stop_btn {
		@apply max-sm:hidden mr-6 cursor-pointer text-xs text-[#A1A3AE];
		button {
			@apply bg-white justify-center rounded-[4px] flex items-center h-[28px] w-[88px];
		}
	}
  .ai_answer_tip{
    @apply text-sm text-[#A0A3AE];
  }
	.copy_btn {
		@apply text-xs text-[#A1A3AE] pl-[22px] cursor-pointer;
		background: url('@/assets/icon_copy.png') no-repeat;
		background-size: 14px 14px;
	}
}

</style>
